<template>
  <Table2 :rows="liquidacionesFiltradas" :columns="columns" columnID="idLiquidacion" :containerClass="'m-0'" :tableClass="'table-hover'" :pagination="true" :perPage="50">
    <template #rows="{ rows }">
      <LiquidacionesRow v-for="row in rows" :key="row.idLiquidacion" :row="row"></LiquidacionesRow>
    </template>
  </Table2>
</template>

<script>
import LiquidacionesRow from "./LiquidacionesRow.vue";
import Table2 from "../../shared/components/Table2.vue";
import { mapGetters } from "vuex";
export default {
  components: { Table2, LiquidacionesRow },
  data() {
    return {
      columns: [
        {
          key: "actions",
          label: "",
          width: 90,
          row_class: "text-center",
        },
        {
          key: "check",
          label: "",
          width: 25,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "codigo",
          label: "Código",
          width: 70,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "fechaHora",
          label: "Fecha",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "modulo",
          label: "Módulo",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "codRegistro",
          label: "Registro",
          width: 70,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "agencia",
          minWidth: 200,
        },
        {
          key: "pasajero",
          minWidth: 200,
        },
        {
          key: "servicios",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "pax",
          label: "PAX",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "chd",
          label: "CHD",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "moneda",
          label: "Moneda",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "suma",
          label: "Monto",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        // {
        //   key: "total",
        //   width: 60,
        //   head_class: "text-center",
        //   row_class: "text-center",
        // },
        {
          key: "usuarioCreador",
          label: "U.C.",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
        {
          key: "usuarioModif",
          label: "U.M.",
          width: 60,
          head_class: "text-center",
          row_class: "text-center",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("liquidaciones", ["liquidacionesFiltradas"]),
  },
};
</script>

<style></style>
